
import { createSlice } from "@reduxjs/toolkit";

const initialState = [
    {
        package_name: 'combo',
        amt: 6250,
        btnTxt: 'choose package',
        features: ['Basic reporting and analytics', 'Chart and email support', 'Access to all basic features']
    },
    {
        package_name: 'platinum',
        amt: 12500,
        btnTxt: 'choose package',
        features: ['Priority Chart and email support', 'Advanced reporting and analytics','Access to all basic features', 'Audit log and data history']
    },
    {
        package_name: 'ultimate',
        amt: 25000,
        btnTxt: 'choose package',
        features: ['Basic reporting and analytics', 'Audit log and data history', 'Personalised priority service','Advanced custom fields']
    }
];

export const investmentPlanSlice = createSlice({
    name: 'invest/packages',
    initialState,
    reducers: {}
});


export default investmentPlanSlice.reducer;